export const sidebarCssClasses = [
  'sidebar-show',
  'sidebar-sm-show',
  'sidebar-md-show',
  'sidebar-lg-show',
  'sidebar-xl-show'
]

export const asideMenuCssClasses = [
  'aside-menu-show',
  'aside-menu-sm-show',
  'aside-menu-md-show',
  'aside-menu-lg-show',
  'aside-menu-xl-show'
]

export const validBreakpoints = ['sm', 'md', 'lg', 'xl']

export function checkBreakpoint (breakpoint, list) {
  return list.indexOf(breakpoint) > -1
}

// export const BaseURLV3 = 'https://dev.screenit.io/api'
// export const BaseURLV3 = 'https://test.screenit.io/api'
// export const BaseURLV3 = 'https://demo.screenit.io/api'
export const BaseURLV3 = 'https://org.screenit.io/api'

// export const BaseURL = 'http://35.154.180.247/api'
// export const BaseURL = 'https://demo.screenit.io/api'
// export const BaseURL = 'https://test.screenit.io/api'
// export const BaseURL = 'https://app.screenit.io/api'
// export const BaseURL = 'https://dev.screenit.io/api'
// export const BaseURL = 'https://org.screenit.io/api'
export const BaseURL = 'https://org.screenit.io/api-v2'
// export const BaseURL = 'http://localhost:5000'
// export const BaseURL2 = 'http://localhost:3000'
export const BaseURL2 = 'https://dev.10xfreshers.net/api/'
